export default __webpack_public_path__ + "static/dot-pattern-609e34f7e2f317ea108dc69b8e33b314.svg";